import { EventEmitter, Injectable } from '@angular/core';
import { Subject, firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { EndPoint } from '../config/endpoint';
import { Notification, NotificationsPagination } from '../interface/notification';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  addNotification = new EventEmitter<boolean>();
  private unreadCountSubject = new Subject<number>();
  unreadNotificationCount = this.unreadCountSubject.asObservable();

  updateUnreadCount(count: number) {
    this.unreadCountSubject.next(count);
  }

  constructor(private httpService: HttpService) {}

  async getNotificationsByUserId(queryParams): Promise<NotificationsPagination> {
    try {
      const notificationsToken = await firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.notifications}`, {
          params: queryParams,
        }),
      );
      return this.httpService.decodeTokenPagination(notificationsToken) as any;
    } catch (error) {
      throw error;
    }
  }

  async getAllNotificationsByUserId(queryParams) {
    try {
      const notificationsToken = await firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.getAllNotificationsByUserId}`, {
          params: queryParams,
        }),
      );
      return this.httpService.decodeToken(notificationsToken);
    } catch (error) {
      throw error;
    }
  }

  async addMultipleNotifications(body) {
    try {
      const notificationsToken = await firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.add_multiple_notifications}`, body),
      );

      return this.httpService.decodeToken(notificationsToken);
    } catch (error) {
      throw error;
    }
  }

  async addNotifications(body) {
    try {
      const token = await firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.notifications}`, body),
      );
      return this.httpService.decodeTokenPagination(token);
    } catch (error) {
      throw error;
    }
  }

  async updateNotification(id: number, body: object): Promise<Notification> {
    try {
      const response = await firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.notifications}/${id}`, body),
      );
      return this.httpService.decryptToken(response) as any;
    } catch (error) {
      throw error;
    }
  }

  async updateMultipleNotifications(body: object) {
    try {
      const token = await firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.update_multiple_notifications}`, body),
      );
      return this.httpService.decodeTokenPagination(token);
    } catch (error) {
      throw error;
    }
  }

  async deleteNotification(id) {
    try {
      return await firstValueFrom(
        this.httpService.delete<any>(`${environment.XANO_SERVER_URL}${EndPoint.notifications}/${id}`),
      );
    } catch (error) {
      throw error;
    }
  }

  async getAllSentNotificationsToUser(queryParams) {
    try {
      const notificationsToken = await firstValueFrom(
        this.httpService.post<any>(
          `${environment.XANO_SERVER_URL}${EndPoint.get_all_sent_notifications_to_user}`,
          queryParams,
        ),
      );
      return notificationsToken;
      // return this.httpService.decodeToken(notificationsToken);
    } catch (error) {
      throw error;
    }
  }
}
